import { IHttpApi } from '@cian/http-api/shared';

import { ResponseError } from '../../errors';
import { prepareAnswers } from '../../mappers/prepareAnswers';
import {
  fetchGetQuestionAnswers,
  TGetQuestionAnswersRequest,
  TGetQuestionAnswersResponse,
} from '../../repositories/newbuilding-reviews/v1/get-question-answers';

export interface IFetchAnswersParams {
  httpApi: IHttpApi;
  parameters: TGetQuestionAnswersRequest;
}

export async function fetchQuestionAnswers({ httpApi, parameters }: IFetchAnswersParams) {
  const result: TGetQuestionAnswersResponse = await fetchGetQuestionAnswers({
    httpApi,
    parameters,
  });

  if (result.statusCode !== 200) {
    throw new ResponseError({
      domain: 'answers#fetchAnswers',
      message: result.response.message as string,
    });
  }

  return prepareAnswers(result.response, parameters.questionId);
}
